import { OrderActionCreators } from "src/store/reducers/order/action-creators";
import { put, takeLatest } from "redux-saga/effects";
import { OrderActionEnum } from "src/store/reducers/order/types";
import instance from "src/sagas/set";


function* fetchShowInsurance({
  key,
}: ReturnType<typeof OrderActionCreators.showInsurance>) {
  try {
    const id = key.split('insurance/')[1];
    const { data } = yield instance.get(`insurance/show/${id}`);
    yield put(OrderActionCreators.resultShowInsurance(data));
  } catch (error: any) {
    console.log(error);
  }
}
export function* actionWatcherShowInsurance() {
  yield takeLatest(OrderActionEnum.REQUEST_SHOW_INSURANCE, fetchShowInsurance);
}
